import { createFilterAdapter } from '@payer-admin-ui/components-v2/src/state/filterAdapter';
import {
  emptyIAFilters,
  type InvoiceAggregationsFilters,
} from 'views/Pages/invoiceAggregations/invoiceAggregationsGlobalState';
import { emptyInvoiceFilters, type InvoiceFilters } from 'views/Pages/invoices/invoicesGlobalState';
import type { AddMappingModalState } from './AddMappingModalStateConstants';

export const invoiceFilterAdapter = createFilterAdapter<AddMappingModalState, InvoiceFilters>({
  selectState: state => state.invoice.filters,
  emptyFilters: emptyInvoiceFilters,
});

export const statementFilterAdapter = createFilterAdapter<AddMappingModalState, InvoiceAggregationsFilters>({
  selectState: state => state.statement.filters,
  emptyFilters: emptyIAFilters,
});
